import attemptToSubmitAddEntityFeedback from './attemptToSubmitAddEntityFeedback';
import createSessionFeedbackEntry from './createSessionFeedbackEntry';
import EntityFeedbackEntry from 'owa-service/lib/contract/EntityFeedbackEntry';
import { action } from 'satcheljs/lib/legacy';
import { FeedbackManagerState } from 'owa-feedback-manager-store/lib/store/schema/FeedbackManagerState';
import { format } from 'owa-strings';
import { trace } from 'owa-trace';

/**
 * Logs 'Pause session' the specified feedbackManagerState
 * @param feedbackManagerState: the feedback manager state
 */
export default action('pauseSession')(function pauseSession(
    feedbackManagerState: FeedbackManagerState
) {
    if (feedbackManagerState) {
        if (feedbackManagerState.hasSessionStarted && !feedbackManagerState.isSessionPaused) {
            let entry: EntityFeedbackEntry = createSessionFeedbackEntry(
                feedbackManagerState,
                'SessionPaused'
            );
            attemptToSubmitAddEntityFeedback(feedbackManagerState, entry, false);
            feedbackManagerState.isSessionPaused = true;

            trace.info(
                format(
                    '{0} pauseSession : Session ended. Session id: {1}',
                    feedbackManagerState.entityScenarioName,
                    feedbackManagerState.clientSessionId
                )
            );
        }
    }
});
